import React, { Component } from "react";
import { Button, Icon, Table } from "semantic-ui-react";
import VendorBranchEdit from "./branchEdit";

import Axios from "axios";
import cogoToast from "cogo-toast";
import { connect } from "react-redux";
import DeleteAxios from "../../../components/axiosComponent/delete";
import ReadAxios from "../../../components/axiosComponent/read";
import {
    errorAlertDispatcher,
    infoAlertDispatcher, successAlertDispatcher,
    warningAlertDispatcher
} from "../../../redux/actions/alertAction";
import { LOCAL_STORAGE } from "../../utils/constants";
import DeleteModal from "./deleteModal";
import DeleteBillingPartyBranchModal from "./deleteBillingPartyBranch";
import {billingPartyBranchConst, buttons} from './billingPartyConstants'
import BranchDetailsModal from "./branchDetailsModal";

export class BranchTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            vendorRateChart: [],
            deleteModalOpen: false,
            ratechart: false,
            edit: {},
            currentObject : {}
        };
    }

    componentDidMount() {
    }

    setDeafultValue = (masterRoute, deafultValue) => {
        ReadAxios({
            url: `${masterRoute}/${deafultValue}`,
        })
            .then((res) => {
                console.log(res.data.resultSet);
            })
            .catch((err) => console.log(err));
    };

    BranchEditModal = (e, data, isEdit = false) => {
        if (data.add_mode === 'add') {
            this.setState({
                branchmodal: true,
                editUserInputs: false,
                edit: null,
            })
        } else if (isEdit) {
            this.setState({
                branchmodal: true,
                editUserInputs: true,
                edit: { ...data },
            })
        } else {
            this.setState({
                deleteModalOpen: true,
                edit: { ...data.user_items },
            })
        }
    };

    BranchModalClose = () => {
        this.setState({ branchmodal: false });
        window.location.reload()
    };
    openDeleteModal = (Obj)=>{
        this.setState({ deleteModalOpen: true , currentObject: Obj});
    };
    closeDeleteModal = () => {
        this.setState({ deleteModalOpen: false });
    };

    getcities = (id) => {
        ReadAxios({ url: `cityMaster/${id}` })
            .then((res) => {
                let city = res.data.resultSet[0].cityName;
                return city;
            })
            .catch((err) => {
                return "NA";
            });
    }

    confirmDelete = () => {
        DeleteAxios({
            completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/rate/${this.state.edit.vendor_rate_id}`,
        })
            .then((res) => {
                let alert = {
                    type: "success",
                    messageHeader: "Success",
                    messageBody: "Vendor rate deleted.",
                };
                this.props.successAlertDispatcher(alert);
                this.closeDeleteModal();
                this.getVendorRateChart();
            })
            .catch((err) => {
                let alert = {
                    type: "error",
                    messageHeader: "Error",
                    messageBody: "Unable to delete vendor rate.",
                };
                console.log(err);
                this.props.errorAlertDispatcher(alert);
                this.closeDeleteModal();
            });
    };

    updatePage = () => {
        this.BranchModalClose();
        window.location.reload();
    };

    deleteBranch = (object) => {
        const gett = LOCAL_STORAGE.userToken;
        const data = {
            customerNumber: LOCAL_STORAGE.customerNo,
            userId: LOCAL_STORAGE.userId
        };
        Axios.delete(`${process.env.REACT_APP_BASE_URL}/masters/billing_party_branch/${object.billingPartyBranchId}`, {
            data: data,
            headers: { 'content-type': 'application/json', 'Authorization': `${gett}` }
        })
            .then(response => {
                if (response.status === 200) {
                    this.closeDeleteModal()
                    cogoToast.success(`${object?.billingPartyBranchName} is Deleted.`, { position: 'top-right' });
                    setTimeout(() => {
                        window.location.reload()
                      }, 1500);
                }
            })
            .catch((err) => {
                if (err.data.status === 204) {
                    cogoToast.error(`Unable to Delete. ${object?.billingPartyBranchName},{ position: 'top-right' }`)
                }
            });
    };

    render() {
        return (
            <>
                {true && (
                    <div className="mb-3">
                        <Table stackable size="small" selectable>
                            <Table.Header className="w3-small">
                                <Table.Row>
                                    <Table.HeaderCell colSpan="7" className="p-bold-600">{billingPartyBranchConst?.table_title||"Branch Details"}</Table.HeaderCell>
                                    <Table.HeaderCell className="p-bold-600" textAlign="right" style={{ position: 'inherit' }}>
                                        <Button
                                            type="button"
                                            className="w3-button w3-blue w3-small w3-round w3-hover-blue"
                                            add_mode="add"
                                            onClick={this.BranchEditModal}
                                        >
                                            <Icon name="plus" />{buttons?.new||"New"}
                                        </Button>
                                    </Table.HeaderCell>
                                </Table.Row>
                                <Table.Row>
                                <Table.HeaderCell className="p-bold-500">{billingPartyBranchConst?.table_headers?.branch_code||"Branch Code"}</Table.HeaderCell>
                                    <Table.HeaderCell className="p-bold-500">{billingPartyBranchConst?.table_headers?.branch||"Branch"}</Table.HeaderCell>
                                    <Table.HeaderCell className="p-bold-500">{billingPartyBranchConst?.table_headers?.gst_no||"GST Number"}</Table.HeaderCell>
                                    <Table.HeaderCell className="p-bold-500">{billingPartyBranchConst?.table_headers?.address||"Address"}</Table.HeaderCell>
                                    <Table.HeaderCell className="p-bold-500">{billingPartyBranchConst?.table_headers?.pincode||"Pincode"}</Table.HeaderCell>
                                    <Table.HeaderCell className="p-bold-500">{billingPartyBranchConst?.table_headers?.more||"More Detail"}</Table.HeaderCell>
                                    <Table.HeaderCell className="p-bold-500">{billingPartyBranchConst?.table_headers?.edit||"Edit"}</Table.HeaderCell>
                                    <Table.HeaderCell className="p-bold-500">{billingPartyBranchConst?.table_headers?.delete||"Delete"}</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            {this.props.BranchList && this.props.BranchList.length > 0 ? (
                                this.props.BranchList.map((object, index) => (
                                    <Table.Row key={index}>
                                        <Table.Cell className="fixedLength150">{object?.billingPartyBranchCode || "NA"}</Table.Cell>
                                        <Table.Cell className="fixedLength150">{object?.billingPartyBranchName || "NA"}</Table.Cell>
                                        <Table.Cell>{object?.billingPartyBranchGst || "NA"}</Table.Cell>
                                        <Table.Cell className="fixedLength150">{object?.billingPartyBranchAddress || "NA"}</Table.Cell>
                                        <Table.Cell>{object?.billingPartyBranchPincode || "NA"}</Table.Cell>
                                        <Table.Cell><BranchDetailsModal data={object} /></Table.Cell>

                                        <Table.Cell>
                                            <i onClick={(e) => this.BranchEditModal(e, object, true)}
                                                className='fas w3-text-green fa-pen w3-button w3-border w3-border-green w3-round p-2'
                                            />
                                        </Table.Cell>
                                        <Table.Cell>
                                            <i onClick={() => this.openDeleteModal(object)}
                                                className='fas w3-text-red fa-trash w3-button w3-border w3-border-red w3-round p-2'
                                            />
                                        </Table.Cell>
                                    </Table.Row>
                                ))
                            ) : (
                                <Table.Row>
                                    <Table.Cell colSpan="6">{"No Record(s) Found"}</Table.Cell>
                                </Table.Row>
                            )}
                        </Table>
                    </div>
                )}
                {/* <DeleteModal
                    deleteOpen={this.state.deleteModalOpen}
                    CloseModal={this.closeDeleteModal}
                    ConfirmDeleteRow={this.confirmDelete}
                /> */}
                <DeleteBillingPartyBranchModal
                deleteOpen={this.state.deleteModalOpen}
                CloseModal={this.closeDeleteModal}
                handleDelete={this.deleteBranch}
                currentObject = {this.state.currentObject}
                notification = "Confirm Delete"
                message = "Are you sure want to delete ?"
                />
                <VendorBranchEdit
                    vendorId={this.props.vendorId}
                    branchModal={this.state.branchmodal}
                    CloseModal={this.BranchModalClose}
                    vendor_code={this.props.vendor_code}
                    editData={this.state.edit}
                    onFormSubmit={this.updatePage}
                    billingPartyID={this.props.billingPartyID}
                />
            </>
        );
    }
}

export default connect(
    null, {
    successAlertDispatcher,
    warningAlertDispatcher,
    errorAlertDispatcher,
    infoAlertDispatcher,
})(BranchTable);
